import React from "react";
import { default as MUIPagination } from "@mui/material/Pagination";
import styled from "styled-components";

const StyledMUIPagination = styled(MUIPagination)``;

export const Pagination = (props) => {
  return <StyledMUIPagination {...props} shape="rounded" />;
};
